import { ReactElement } from "react";
import { Link } from "react-router-dom";

/**
 * Shown when someone reaches the page without
 * `initiate_new_Portfolio_aggreement`.
 *
 * Routes in this app are not permission-guarded — entry points are hidden
 * instead — so the page is reachable by URL. The backend enforces the
 * permission regardless; this only avoids presenting a form whose every
 * action would be rejected.
 */
const NoAccess: React.FC = (): ReactElement => (
  <div className="panel">
    <div className="no-access">
      <span className="icon">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4.5" y="10.5" width="15" height="10" rx="2" />
          <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
        </svg>
      </span>
      <h4>You do not have access to bulk initiation</h4>
      <p>
        This page needs the <strong>initiate new portfolio agreement</strong>{" "}
        permission. Ask an administrator if you believe you should have it.
      </p>
      <Link to="/portfolio?tab=4" className="btn ghost">
        Back to portfolio agreements
      </Link>
    </div>
  </div>
);

export default NoAccess;
